class FeaturedProducts extends HTMLElement {
  constructor() {
    super();
    this.imageSlide = this.querySelector("[data-image-slide]");
    this.copySlide = this.querySelector("[data-copy-slide]");

    window.loadSwiper.then(({ Swiper }) => {
      const swiperParamsCopy = {
        slidesPerView: "auto",
        cssMode: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      };

      const swiperParamsImages = {
        slidesPerView: "auto",
        cssMode: false,
        noSwiping: true,
        noSwipingClass: "swiper-slide",
        allowTouchMove: false,
      };

      this.imageSwiper = new Swiper(this.imageSlide, swiperParamsImages);
      this.copySwiper = new Swiper(this.copySlide, swiperParamsCopy);

      this.copySwiper.on("slideChange", () => {
        const index = this.copySwiper.realIndex;
        this.imageSwiper.slideTo(index, 0);
      });
    });
  }
}

if (!customElements.get("featured-products")) {
  customElements.define("featured-products", FeaturedProducts);
}
